[
  { "id": "zwykly", "name": "Zwykły", "color": "#b9b4a8", "weight": 60, "statMultiplier": 1 },
  { "id": "rzadki", "name": "Rzadki", "color": "#4a9eff", "weight": 28, "statMultiplier": 1.6 },
  { "id": "epicki", "name": "Epicki", "color": "#b45cff", "weight": 10, "statMultiplier": 2.4 },
  { "id": "legendarny", "name": "Legendarny", "color": "#ff9a1f", "weight": 2, "statMultiplier": 3.5 }
]
